// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

// Project imports

import Button from '../../../../components/Button';
import AlertMessage from '../../../../components/AlertMessage';
import RFTextField from '../../../../components/RFTextField';
import { required, confirmNewPassword } from '../../../../utils/validators';

import './styles.css';

// Component

class ChangePasswordForm extends Component {
  _submit = (formValues) => {
    this.props.onSubmit(formValues);
  };

  render() {
    const {
      handleSubmit, invalid, ui, onlyNewPassword,
    } = this.props;

    return (
      <form onSubmit={handleSubmit(this._submit)}>
        {!onlyNewPassword && (
          <Field
            name="currentPassword"
            validate={required}
            floatingLabelText="Senha atual"
            fullWidth
            props={{
              type: 'password',
            }}
            component={RFTextField}
          />
        )}
        <Field
          name="newPassword"
          validate={required}
          floatingLabelText="Nova senha"
          fullWidth
          props={{
            type: 'password',
          }}
          component={RFTextField}
        />
        <Field
          name="confirmNewPassword"
          validate={[required, confirmNewPassword]}
          floatingLabelText="Confirme a nova senha"
          fullWidth
          props={{
            type: 'password',
          }}
          component={RFTextField}
        />
        {ui.error && <AlertMessage error box message={ui.error} />}
        <div className="UpdatePassword__actions">
          <Button
            type="submit"
            disabled={invalid || ui.isFetching}
            text="Alterar"
            skin="primary"
          />
        </div>
      </form>
    );
  }
}

// Redux

const mapStateToProps = (ownProps) => {
  const { onlyNewPassword } = ownProps;
  return {
    initialValues: {
      ...(onlyNewPassword ? {} : { currentPassword: '' }),
      newPassword: '',
      confirmNewPassword: '',
    },
  };
};

export default connect(mapStateToProps)(reduxForm({ form: 'changePassword' })(ChangePasswordForm));
